import * as React from 'react';
import { useNavigate } from 'react-router';
import type { PiletApi } from '@chess/platform-web';
import { libraryLink, type FilterLink } from '@chess/api-insights/charts';
import { registerCard } from '@chess/api-dashboard';
import { registerAggregator, useAggregate } from '@chess/api-model/react';
import '@chess/api-insights/charts.css';
import { StageFlowCard } from './StageFlowCard.tsx';
import { StageFlowAggregator } from './StageFlowAggregator.ts';

// Overview card "How each stage goes" (2026-10-08): registers its own
// aggregator with the game store, reads its result and renders
// `StageFlowCard`, its body, in a wide frame across the Summary section's
// width (`registerCard` on `home.section.summary`, order 40). A segment opens the library filtered to its games
// (`libraryLink`).
export function setup(app: PiletApi) {
  const getApi = <T,>(name: string) => app.getApi<T>(name);
  const aggregator = new StageFlowAggregator();
  registerAggregator(getApi, aggregator);
  const Card: React.FC = () => {
    const { result, state } = useAggregate(getApi, aggregator);
    const navigate = useNavigate();
    const link = React.useMemo<FilterLink>(() => libraryLink((path) => navigate(path)), [navigate]);
    return result && state?.status === 'ready' ? <StageFlowCard result={result} link={link} /> : null;
  };
  registerCard(app, 'home.section.summary', Card, { order: 40, title: 'How each stage goes', wide: true });
}
